import React from "react";
import { Button, Input, Form } from "antd";
import PhoneInput from "antd-phone-input";
import { FormattedMessage } from "react-intl";
import { WhatsappSVG } from "../WhatsappSVG";
import { ActionFooter } from "../components/ActionFooter";

export function WhatsappInputScreen({
	primaryColor,
	phoneNumber,
	handlePhoneNumberChange,
	contactName,
	handleContactNameChange,
	companyName,
	handleCompanyNameChange,
	sendWhatsApp,
	isNavigating,
}) {
	return (
		<>
			<div className="bg-white min-h-[596px] max-h-[596px] flex flex-col items-center justify-center">
				<div className="mb-6 w-72 h-auto">
					<div className="w-full h-auto [&>svg]:w-full [&>svg]:h-auto [&>svg]:max-w-80">
						<WhatsappSVG color={primaryColor} />
					</div>
				</div>
				<div className="text-center mb-4">
					<h3 className="text-lg font-medium mb-2">
						<FormattedMessage
							id="whatsapp.form_title"
							defaultMessage="Envio de captura pelo WhatsApp"
						/>
					</h3>
				</div>
				<div className="w-full max-w-md">
					<Form layout="vertical" className="gap-5">
						<Form.Item
							required
							label={
								<FormattedMessage
									id="whatsapp.contact_name"
									defaultMessage="Nome do contato"
								/>
							}
						>
							<Input
								size="large"
								placeholder="Digite o nome do contato"
								value={contactName}
								onChange={(e) => handleContactNameChange(e.target.value)}
							/>
						</Form.Item>
						<Form.Item
							required
							label={
								<FormattedMessage
									id="whatsapp.company_name"
									defaultMessage="Empresa solicitante"
								/>
							}
						>
							<Input
								size="large"
								placeholder="Digite o nome da empresa solicitante"
								value={companyName}
								onChange={(e) => handleCompanyNameChange(e.target.value)}
							/>
						</Form.Item>
						<Form.Item
							required
							label={
								<FormattedMessage
									id="whatsapp.phone_number"
									defaultMessage="Número do WhatsApp"
								/>
							}
						>
							<PhoneInput
								size="large"
								value={phoneNumber}
								onChange={handlePhoneNumberChange}
								enableArrow={false}
								enableSearch
								className="custom-phone-input"
							/>
						</Form.Item>
					</Form>
				</div>
			</div>
			<ActionFooter>
				<Button
					size="large"
					shape="round"
					type="primary"
					className="border-0 text-white !px-12 shadow-none"
					disabled={
						!(
							phoneNumber &&
							typeof phoneNumber.valid === "function" &&
							phoneNumber.valid() &&
							contactName.trim() &&
							companyName.trim()
						) || isNavigating
					}
					loading={isNavigating}
					onClick={sendWhatsApp}
				>
					<FormattedMessage id="send" />
				</Button>
			</ActionFooter>
		</>
	);
}
